import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useVouchersReport } from "../../hooks/useVouchersReport";
import { useDownloadVouchersReportCsv } from "../../hooks/useDownloadVouchersReportCsv";
import { vouchersReportColumns } from "../VouchersReportColumns/VouchersReportColumns";
import VouchersReportFilters from "../VouchersReportFilters/VouchersReportFilters";
import { VouchersReportItem } from "../../api/fetchVouchersReport/types";

const columns = vouchersReportColumns();

const VouchersReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useVouchersReport();

  const { loading: csvLoading, downloadCsv } = useDownloadVouchersReportCsv();

  return (
    <MainPageWrapper title="Vouchers Report">
      <VouchersReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />
      <DataTable<VouchersReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No vouchers found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default VouchersReportPage;
